import { render, staticRenderFns } from "./SetupAccount.vue?vue&type=template&id=6069972a&"
import script from "./SetupAccount.vue?vue&type=script&lang=js&"
export * from "./SetupAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports